import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SyllabusService } from '@examdojo/category/v2';
import { mapToVoid } from '@examdojo/core/rxjs';
import { first, of, tap } from 'rxjs';
import { ClassQuery } from '../class/class.query';
import { ClassAssignmentQuery } from './class-assignment.query';

export const classSyllabusActiveResolver: ResolveFn<void> = () => {
  const classAssignmentQuery = inject(ClassAssignmentQuery);
  const classQuery = inject(ClassQuery);
  const syllabusService = inject(SyllabusService);

  const assignment = classAssignmentQuery.getActive();
  if (!assignment?.class_id) {
    console.error('[classSyllabusActiveResolver]: No active assignment or class_id');
    return of(undefined);
  }

  const classEntity = classQuery.getEntity(assignment.class_id);
  if (!classEntity?.syllabus_id) {
    console.error('[classSyllabusActiveResolver]: Class entity not found or missing syllabus_id');
    return of(undefined);
  }

  return syllabusService.fetchActiveSyllabuses().pipe(
    first(),
    tap(() => syllabusService.setActive(classEntity.syllabus_id, classEntity.course_level)),
    mapToVoid(),
  );
};
